import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constans/rutas";
import AuthContex from "../../context/autenticacion/authContex";
import logo from "../../asses/img/parkingl.png";
import {
  actualizarCliente,
  consultarAuditoriaClientes,
  consultarClientes,
} from "./consultarClientes";
import "./Clientes.css";

const USUARIO_CLIENTES_AUDI = "david.barreto@parking.net.co";
const USUARIOS_CLIENTES = new Set([
  USUARIO_CLIENTES_AUDI,
  "lency.camacho@parking.net.co",
]);

const FILTROS_VACIOS = {
  numeroNit: "",
  razonSocial: "",
  identificacion: "",
  nombre: "",
  apellido: "",
  email: "",
  celular: "",
};

const COLUMNAS_JURIDICO = [
  ["id", "Id"],
  ["numero_nit", "NIT"],
  ["razon_social", "Razón social"],
  ["email", "Email"],
  ["celular", "Celular"],
  ["actividad_economica", "Actividad económica"],
  ["direccion", "Dirección"],
  ["ciudad", "Ciudad"],
  ["fecha_creacion", "Fecha creación"],
];

const COLUMNAS_NATURAL = [
  ["id", "Id"],
  ["identificacion", "Identificación"],
  ["nombre", "Nombre"],
  ["apellido", "Apellido"],
  ["email", "Email"],
  ["celular", "Celular"],
  ["actividad_economica", "Actividad económica"],
  ["direccion", "Dirección"],
  ["ciudad", "Ciudad"],
  ["fecha_creacion", "Fecha creación"],
];

const CAMPOS_JURIDICO = [
  ["numeroNit", "NIT", "Número de NIT"],
  ["razonSocial", "Razón social", "Razón social"],
  ["email", "Email", "Correo"],
  ["celular", "Celular", "Celular"],
];

const CAMPOS_NATURAL = [
  ["identificacion", "Identificación", "Cédula u otro documento"],
  ["nombre", "Nombre", "Nombre"],
  ["apellido", "Apellido", "Apellido"],
  ["email", "Email", "Correo"],
  ["celular", "Celular", "Celular"],
];

const EDITABLES_JURIDICO = [
  "razon_social",
  "email",
  "celular",
  "direccion",
  "ciudad",
];

const EDITABLES_NATURAL = [
  "nombre",
  "apellido",
  "email",
  "celular",
  "direccion",
  "ciudad",
];

const CAMPOS_API = {
  razon_social: "razonSocial",
  email: "email",
  celular: "celular",
  direccion: "direccion",
  ciudad: "ciudad",
  nombre: "nombre",
  apellido: "apellido",
};

const CAMPOS_TEXTO = new Set([
  "numero_nit",
  "identificacion",
  "celular",
  "actividad_economica",
]);

const mensajeErrorApi = (error) => {
  const data = error.response && error.response.data;
  if (!data) return error.message || "Error al consultar clientes.";
  if (Array.isArray(data.message)) return data.message.join(" ");
  return data.message || data.error || error.message || "Error al consultar clientes.";
};

const formatearValor = (campo, valor) => {
  if (valor === null || valor === undefined || valor === "") return "";
  if (campo === "fecha_creacion") {
    const fecha = new Date(valor);
    if (Number.isNaN(fecha.getTime())) return String(valor);
    return fecha.toLocaleString("es-CO");
  }
  if (CAMPOS_TEXTO.has(campo) && typeof valor === "number") {
    return Number.isSafeInteger(valor) ? String(valor) : valor.toFixed(0);
  }
  return String(valor);
};

const hayAlgunFiltro = (tipo, filtros) => {
  const campos = tipo === "juridico" ? CAMPOS_JURIDICO : CAMPOS_NATURAL;
  return campos.some(([nombre]) => String(filtros[nombre] || "").trim());
};

const valoresEdicion = (fila, editables) => {
  const datos = {};
  editables.forEach((campo) => {
    datos[campo] = formatearValor(campo, fila[campo]);
  });
  return datos;
};

const formatearFechaAudi = (fecha) => {
  if (!fecha) return "";
  const date = new Date(fecha);
  if (Number.isNaN(date.getTime())) return String(fecha);
  return date.toLocaleString("es-CO");
};

const ClientesPage = () => {
  const history = useHistory();
  const authContex = useContext(AuthContex);
  const usuario = authContex && authContex.usuario;
  const emailUsuario = String((usuario && (usuario.email || usuario.correo)) || "")
    .toLowerCase()
    .replace(/\s+/g, "")
    .trim();
  const puedeVerModulo = USUARIOS_CLIENTES.has(emailUsuario);
  const puedeVerAudi = emailUsuario === USUARIO_CLIENTES_AUDI;

  useEffect(() => {
    if (!usuario) return;
    if (!puedeVerModulo) {
      history.replace(ROUTES.HOME);
    }
  }, [usuario, puedeVerModulo, history]);
  const [tipo, setTipo] = useState("juridico");
  const [filtros, setFiltros] = useState(FILTROS_VACIOS);
  const [registros, setRegistros] = useState([]);
  const [total, setTotal] = useState(0);
  const [limite, setLimite] = useState(0);
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [consultaHecha, setConsultaHecha] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [formEdicion, setFormEdicion] = useState({});
  const [verAudi, setVerAudi] = useState(false);
  const [nitAudi, setNitAudi] = useState("");
  const [registrosAudi, setRegistrosAudi] = useState([]);
  const [cargandoAudi, setCargandoAudi] = useState(false);
  const [errorAudi, setErrorAudi] = useState("");

  const columnas = tipo === "juridico" ? COLUMNAS_JURIDICO : COLUMNAS_NATURAL;
  const campos = tipo === "juridico" ? CAMPOS_JURIDICO : CAMPOS_NATURAL;
  const editables = tipo === "juridico" ? EDITABLES_JURIDICO : EDITABLES_NATURAL;

  const limpiarEdicion = () => {
    setEditandoId(null);
    setFormEdicion({});
  };

  const cambiarTipo = (siguiente) => {
    setTipo(siguiente);
    setFiltros(FILTROS_VACIOS);
    setRegistros([]);
    setTotal(0);
    setError("");
    setMensaje("");
    setConsultaHecha(false);
    limpiarEdicion();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const buscar = async (e) => {
    e.preventDefault();
    if (!hayAlgunFiltro(tipo, filtros)) {
      setError("Ingresa al menos un dato. No es necesario llenar todos los campos.");
      setMensaje("");
      setRegistros([]);
      setConsultaHecha(false);
      return;
    }

    setCargando(true);
    setError("");
    setMensaje("");
    limpiarEdicion();
    try {
      const payload = await consultarClientes({ ...filtros, tipo });
      const lista = Array.isArray(payload)
        ? payload
        : Array.isArray(payload && payload.data)
          ? payload.data
          : [];
      setRegistros(lista);
      setTotal(
        payload && typeof payload.total === "number" ? payload.total : lista.length
      );
      setLimite((payload && payload.limite) || 0);
      setConsultaHecha(true);
    } catch (err) {
      setRegistros([]);
      setTotal(0);
      setConsultaHecha(true);
      setError(mensajeErrorApi(err));
    } finally {
      setCargando(false);
    }
  };

  const limpiar = () => {
    setFiltros(FILTROS_VACIOS);
    setRegistros([]);
    setTotal(0);
    setError("");
    setMensaje("");
    setConsultaHecha(false);
    limpiarEdicion();
  };

  const empezarEdicion = (fila) => {
    setError("");
    setMensaje("");
    setEditandoId(fila.id);
    setFormEdicion(valoresEdicion(fila, editables));
  };

  const cambiarEdicion = (campo, valor) => {
    setFormEdicion((prev) => ({ ...prev, [campo]: valor }));
  };

  const cargarAudi = async (nit) => {
    setCargandoAudi(true);
    setErrorAudi("");
    try {
      const payload = await consultarAuditoriaClientes(nit);
      const lista = Array.isArray(payload)
        ? payload
        : Array.isArray(payload && payload.data)
          ? payload.data
          : [];
      setRegistrosAudi(lista);
      setVerAudi(true);
    } catch (err) {
      setRegistrosAudi([]);
      setErrorAudi(mensajeErrorApi(err));
    } finally {
      setCargandoAudi(false);
    }
  };

  const guardarEdicion = async (id) => {
    const datos = { tipo };
    editables.forEach((campo) => {
      datos[CAMPOS_API[campo]] = String(formEdicion[campo] || "").trim();
    });

    setGuardando(true);
    setError("");
    setMensaje("");
    try {
      const payload = await actualizarCliente(id, datos);
      const fila = payload && payload.data ? payload.data : null;
      setRegistros((prev) =>
        prev.map((item) => (item.id === id && fila ? { ...item, ...fila } : item))
      );
      limpiarEdicion();
      setMensaje("Los datos del cliente se actualizaron.");
    } catch (err) {
      setError(mensajeErrorApi(err));
    } finally {
      setGuardando(false);
    }
  };

  if (usuario && !puedeVerModulo) {
    return null;
  }

  return (
    <div className="clientes-page">
      <div className="clientes-encabezado">
        <div className="clientes-marca">
          <img src={logo} alt="Parking" />
          <h1>Clientes</h1>
        </div>
        <div className="clientes-encabezado-acciones">
          {puedeVerAudi ? (
            <button
              type="button"
              className="clientes-btn clientes-btn--verde"
              onClick={() => (verAudi ? setVerAudi(false) : cargarAudi(nitAudi))}
              disabled={cargandoAudi}
            >
              {cargandoAudi ? "Cargando..." : "ClientesAudi"}
            </button>
          ) : null}
          <button
            type="button"
            className="clientes-volver"
            onClick={() => history.push(ROUTES.HOME)}
          >
            Inicio
          </button>
        </div>
      </div>

      <div className="clientes-tabs">
        <button
          type="button"
          className={`clientes-tab${tipo === "juridico" ? " clientes-tab--activo" : ""}`}
          onClick={() => cambiarTipo("juridico")}
          disabled={cargando || guardando}
        >
          Jurídico
        </button>
        <button
          type="button"
          className={`clientes-tab${tipo === "natural" ? " clientes-tab--activo" : ""}`}
          onClick={() => cambiarTipo("natural")}
          disabled={cargando || guardando}
        >
          Natural
        </button>
      </div>

      {puedeVerAudi && verAudi ? (
        <section className="clientes-audi">
          <h2>Auditoría de clientes</h2>
          <form
            className="clientes-audi-filtro"
            onSubmit={(e) => {
              e.preventDefault();
              cargarAudi(nitAudi);
            }}
          >
            <label htmlFor="clientes-audi-nit">NIT</label>
            <input
              id="clientes-audi-nit"
              type="text"
              value={nitAudi}
              onChange={(e) => setNitAudi(e.target.value)}
              placeholder="Opcional"
              disabled={cargandoAudi}
            />
            <button
              type="submit"
              className="clientes-btn clientes-btn--primario"
              disabled={cargandoAudi}
            >
              Buscar
            </button>
          </form>
          {errorAudi ? (
            <div className="clientes-aviso clientes-aviso--error">{errorAudi}</div>
          ) : null}
          {registrosAudi.length === 0 && !errorAudi ? (
            <div className="clientes-vacio">No hay modificaciones de clientes.</div>
          ) : null}
          {registrosAudi.length > 0 ? (
            <div className="clientes-tabla-wrap">
              <table className="clientes-tabla">
                <thead>
                  <tr>
                    <th>Usuario</th>
                    <th>Acción</th>
                    <th>Fecha</th>
                    <th>NIT</th>
                    <th>Detalle</th>
                  </tr>
                </thead>
                <tbody>
                  {registrosAudi.map((fila, index) => (
                    <tr key={fila.id || index}>
                      <td>{fila.usuario || ""}</td>
                      <td>{fila.accion || ""}</td>
                      <td>{formatearFechaAudi(fila.fecha)}</td>
                      <td className="clientes-texto">{fila.terminal || ""}</td>
                      <td className="clientes-detalle">{fila.detalle || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </section>
      ) : null}

      <p className="clientes-ayuda">
        Puedes consultar con un solo dato. En la tabla puedes modificar{" "}
        {tipo === "juridico"
          ? "razón social, email, celular, dirección y ciudad."
          : "nombre, apellido, email, celular, dirección y ciudad."}
      </p>

      <form className="clientes-form" onSubmit={buscar}>
        {campos.map(([nombre, etiqueta, placeholder]) => (
          <div className="clientes-campo" key={nombre}>
            <label htmlFor={`cliente-${nombre}`}>
              {etiqueta} <span className="clientes-opcional">(opcional)</span>
            </label>
            <input
              id={`cliente-${nombre}`}
              type="text"
              name={nombre}
              value={filtros[nombre]}
              onChange={handleChange}
              disabled={cargando || guardando}
              placeholder={placeholder}
            />
          </div>
        ))}
        <div className="clientes-acciones-form">
          <button
            type="submit"
            className="clientes-btn clientes-btn--primario"
            disabled={cargando || guardando}
          >
            {cargando ? "Consultando..." : "Buscar"}
          </button>
          <button
            type="button"
            className="clientes-btn clientes-btn--claro"
            onClick={limpiar}
            disabled={cargando || guardando}
          >
            Limpiar
          </button>
        </div>
      </form>

      {error ? <div className="clientes-aviso clientes-aviso--error">{error}</div> : null}
      {mensaje ? <div className="clientes-aviso clientes-aviso--ok">{mensaje}</div> : null}

      {consultaHecha && !error ? (
        <p className="clientes-resumen">
          {total} cliente(s) {tipo === "juridico" ? "jurídico(s)" : "natural(es)"}
          {limite && total >= limite ? ` (se muestran los ${limite} más recientes)` : ""}.
        </p>
      ) : null}

      {consultaHecha && !error && registros.length === 0 ? (
        <div className="clientes-vacio">No se encontraron clientes con esos datos.</div>
      ) : null}

      {registros.length > 0 ? (
        <div className="clientes-tabla-wrap">
          <table className="clientes-tabla">
            <thead>
              <tr>
                {columnas.map(([campo, etiqueta]) => (
                  <th key={campo}>{etiqueta}</th>
                ))}
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {registros.map((fila, index) => {
                const enEdicion = editandoId === fila.id;
                return (
                  <tr
                    key={fila.id || index}
                    className={enEdicion ? "clientes-fila-edicion" : undefined}
                  >
                    {columnas.map(([campo]) => (
                      <td
                        key={campo}
                        className={
                          CAMPOS_TEXTO.has(campo) ? "clientes-texto" : undefined
                        }
                      >
                        {enEdicion && editables.includes(campo) ? (
                          <input
                            className="clientes-input"
                            type={campo === "email" ? "email" : "text"}
                            value={formEdicion[campo] || ""}
                            onChange={(e) => cambiarEdicion(campo, e.target.value)}
                            disabled={guardando}
                          />
                        ) : (
                          formatearValor(campo, fila[campo])
                        )}
                      </td>
                    ))}
                    <td>
                      <div className="clientes-acciones">
                        {enEdicion ? (
                          <>
                            <button
                              type="button"
                              className="clientes-btn clientes-btn--verde"
                              onClick={() => guardarEdicion(fila.id)}
                              disabled={guardando}
                            >
                              {guardando ? "Guardando..." : "Guardar"}
                            </button>
                            <button
                              type="button"
                              className="clientes-btn clientes-btn--claro"
                              onClick={limpiarEdicion}
                              disabled={guardando}
                            >
                              Cancelar
                            </button>
                          </>
                        ) : (
                          <button
                            type="button"
                            className="clientes-btn clientes-btn--primario"
                            onClick={() => empezarEdicion(fila)}
                            disabled={guardando || editandoId !== null}
                          >
                            Editar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
};

export default ClientesPage;
